const actionTypes = { SET_GALLERY_CONTENT: 'SET_GALLERY_CONTENT' };

module.exports = actionTypes;
